import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Globals } from '../shared/globals';
import { TranslateService } from '@ngx-translate/core';
import { StationAccessUser } from '../models/station-access-user.model';
import { SpecialUserModel } from '../models/special-user-model.model';
import { BulkSpecialUsers } from '../models/bulk-special-users.model';

@Injectable()
export class SpecialUserService {
  private getSpecialUsersUrl: string;
  private putSpecialUsersUrl: string;
  private manageSpecialUsersUrl: string;
  public translate: TranslateService;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals,
    translate: TranslateService
  ) {
    this.getSpecialUsersUrl = globals.apiUrl(
      'users/stations/{stationId}/connectors/{connectorId}/special_users'
    );
    this.putSpecialUsersUrl = globals.apiUrl(
      'users/stations/{stationId}/connectors/{connectorId}/special_users'
    );
    this.manageSpecialUsersUrl = globals.apiUrl(
      'users/stations/connectors/special_users'
    );
    this.translate = translate;
  }

  getSpecialUsers(
    stationId: string,
    connectorId: number
  ): Promise<StationAccessUser[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .get(
            this.getSpecialUsersUrl
              .replace('{stationId}', stationId)
              .replace('{connectorId}', connectorId.toString()),
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: basicToken,
              },
            }
          )
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch(this.handleError);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  putSpecialUsers(
    stationId: string,
    connectorId: number,
    specialUsers: SpecialUserModel[]
  ): Promise<StationAccessUser[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .put(
            this.putSpecialUsersUrl
              .replace('{stationId}', stationId)
              .replace('{connectorId}', connectorId.toString()),
            specialUsers,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: basicToken,
              },
            }
          )
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch(this.handleError);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  manageSpecialUsers(bulkSpecialUsers: BulkSpecialUsers) {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .put(this.manageSpecialUsersUrl, bulkSpecialUsers, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch(this.handleError);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  private handleError(error: any): Promise<any> {
    // console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error);
  }
}
